import { render, staticRenderFns } from "./CourseBundleLog.vue?vue&type=template&id=8fe07002&scoped=true&"
import script from "./CourseBundleLog.vue?vue&type=script&lang=js&"
export * from "./CourseBundleLog.vue?vue&type=script&lang=js&"
import style0 from "./CourseBundleLog.vue?vue&type=style&index=0&id=8fe07002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe07002",
  null
  
)

export default component.exports